import { type MotionValue } from 'motion/react'
import { type ReactNode } from 'react'
import { Button } from '@/components/Button'
import {
  StickyViewHeader,
  StickyViewHeaderExtras,
  StickyViewHeaderMain,
} from '@/components/StickyViewHeader'

export interface StaffingHeaderProps {
  scrollOffset: MotionValue<number>
  onNewPost: () => unknown
  children?: ReactNode
}

export function StaffingHeader({
  scrollOffset,
  onNewPost,
  children,
}: StaffingHeaderProps) {
  return (
    <StickyViewHeader scrollOffset={scrollOffset}>
      <StickyViewHeaderMain>{children}</StickyViewHeaderMain>
      <StickyViewHeaderExtras>
        <Button
          label="New Post"
          variant="secondary"
          iconLeft="add"
          iconSize={16}
          onPress={onNewPost}
        />
      </StickyViewHeaderExtras>
    </StickyViewHeader>
  )
}
